import { useEffect } from 'react';

/**
 * Locks `<body>` scroll while `locked` is true.
 * Only applies below the `lg` breakpoint (1024px) so desktop layout
 * is never accidentally frozen by mobile-only sheets/modals.
 */
export function useLockBodyScroll(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;

    const mq = window.matchMedia('(max-width: 1023px)');
    if (!mq.matches) return;

    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleChange = (e: MediaQueryListEvent) => {
      if (!e.matches) document.body.style.overflow = prev;
    };
    mq.addEventListener('change', handleChange);

    return () => {
      document.body.style.overflow = prev;
      mq.removeEventListener('change', handleChange);
    };
  }, [locked]);
}
